<div class="loader-full-width">
  <div class="loader-wrapper">
    <img src="https://linckia.cdn.greythr.com/assets/app-loading.gif" alt="Loading just a moment...">
  </div>
</div>
